import { useState, useEffect } from 'react';
import clsx from 'clsx';
import bgDeal from '../../styles/img/midiDeal/dealBg.png';
import wheel from '../../styles/img/midiDeal/wheelBlur.png';
import iconFood from '../../styles/img/midiDeal/iconFood.svg';
import iconSnack from '../../styles/img/midiDeal/iconSnack.svg';
import iconDrink from '../../styles/img/midiDeal/iconDrink.svg';

const MidiDealBackground = () => (
    <>
        <img src={bgDeal} alt="bgDeal" className="w-[100dvw] h-[100dvh] object-cover absolute inset-0" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 opacity-[0.08] -translate-y-2/3 w-[200%] aspect-square flex justify-center items-center">
            <img src={wheel} alt="wheel" className="w-full h-full object-contain animate-[spin_50s_linear_infinite]" />
        </div>
    </>
);

const MidiDealIcon = ({ src, alt, size = "w-8", delay }) => (
    <div
        style={{
            background: "linear-gradient(107.64deg, #FFDE59 64.66%, #F19F10 100.98%)",
            animationDelay: delay
        }}
        className="w-24 h-24 rounded-full flex items-center justify-center border border-4 border-[#986f00d8] animate-pop-in opacity-0"
    >
        <img src={src} alt={alt} className={clsx(size, "h-auto")} />
    </div>
);

const MidiDealIcons = ({ showFoodIcon, showSnackIcon, showDrinkIcon }) => (
    <div className="flex items-center -space-x-4 mb-4">
        {showFoodIcon && <MidiDealIcon src={iconFood} alt="food" delay="0.2s" />}
        {showSnackIcon && <MidiDealIcon src={iconSnack} alt="snack" delay="0.4s" />}
        {showDrinkIcon && <MidiDealIcon src={iconDrink} alt="drink" size="w-4" delay="0.6s" />}
    </div>
);

const MidiDealContent = ({ topTitle, description, dealTitle, price, showFoodIcon, showSnackIcon, showDrinkIcon, onClose }) => (
    <div className="absolute inset-0 flex flex-col items-center justify-start mt-44 px-6">
        <h2 className="text-white text-5xl geomanistBold font-medium mb-6 animate-fade-in opacity-0">
            {topTitle}
        </h2>

        <MidiDealIcons
            showFoodIcon={showFoodIcon}
            showSnackIcon={showSnackIcon}
            showDrinkIcon={showDrinkIcon}
        />

        <p
            className="text-white/80 text-2xl mb-6 geomanistMedium animate-fade-in opacity-0"
            style={{ animationDelay: '0.8s' }}
        >
            {description}
        </p>

        <h1
            className="text-[#F5D547] geomanistBold text-4xl font-bold mb-1 animate-pop-in opacity-0"
            style={{ animationDelay: '1s' }}
        >
            {dealTitle}
        </h1>

        <p
            className="text-[#F5D547] geomanistBold text-5xl mt-4 font-bold animate-pop-in opacity-0"
            style={{ animationDelay: '1.2s' }}
        >
            {price}
        </p>

    </div>
);

export const MidiDealProductScan = ({
    open = true,
    topTitle = "En ce moment",
    description = "1 repas + 1 snack + 1 boisson*",
    dealTitle = "Midi Deal",
    price,
    showFoodIcon = true,
    showSnackIcon = true,
    showDrinkIcon = true,
}) => {
    const [shouldRender, setShouldRender] = useState(open);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        if (open) {
            setShouldRender(true);
            setIsExiting(false);
        } else {
            setIsExiting(true);
            const timer = setTimeout(() => {
                setShouldRender(false);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [open]);

    useEffect(() => {
        return () => setShouldRender(false);
    }, []);

    if (!shouldRender) return null;

    return (
        <div className={clsx("w-[100dvw] pointer-events-none h-[100dvh] fixed top-0 left-0 right-0 bottom-0 z-[1200]", { 'animate-fade-out': isExiting, 'animate-fade-in': !isExiting })}>
            <MidiDealBackground />
            <MidiDealContent
                topTitle={topTitle}
                description={description}
                dealTitle={dealTitle}
                price={price}
                showFoodIcon={showFoodIcon}
                showSnackIcon={showSnackIcon}
                showDrinkIcon={showDrinkIcon}
            />
        </div>
    );
};